module.exports = "<div class=\"survey-gizmo-page\">\n    <iframe\n        #iframe\n        class=\"survey-gizmo-iframe\"\n        [src]=\"surveyUrl | safeHttp\"\n        (load)=\"resizeIframe()\"\n        frameborder=\"0\"\n        width=\"100%\">\n    </iframe>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/study-container-page/survey-gizmo-page/survey-gizmo-page.component.html
// module id = ./src/app/pages/study-container-page/survey-gizmo-page/survey-gizmo-page.component.html
// module chunks = main